import type { RefreshTokenResponse } from '../server/api/auth/refreshToken';
export default async function refreshTokenUtily(refreshToken: string) {
  // Tenta renovar o token
  const { data, error } = await useFetch<RefreshTokenResponse>('/api/auth/refreshToken', {
    method: 'POST',
    body: { refresh_token: refreshToken },
  });

  if (error.value || !data.value) {
    // Falha ao renovar, redireciona para login
    await navigateTo(useUseRouteCallbackUrl('/signin'));
    return;
  }

  // Atualiza tokens no store
  const { access_token, refresh_token, expires_in } = data.value;

  await useUpdateSession({
    session: {
      user: {
        access_token,
        refresh_token,
        expires_in,
      },
    },
  });

  await navigateTo(useUseRouteCallbackUrl('/session-expired'), { replace: true });
}
